import { useCallback, useEffect, useState } from 'react';

import { fetchKioskSetupData } from './kioskApi';

export function useKioskSetupData() {
  const [devices, setDevices] = useState([]);
  const [bindings, setBindings] = useState([]);
  const [requests, setRequests] = useState([]);
  const [requestLoads, setRequestLoads] = useState([]);
  const [loadState, setLoadState] = useState({ type: 'idle', message: '' });
  const [visibilityRefreshTick, setVisibilityRefreshTick] = useState(0);

  const refreshVisibleData = useCallback(() => {
    setVisibilityRefreshTick((tick) => tick + 1);
  }, []);

  useEffect(() => {
    let active = true;

    async function loadSetupData() {
      setLoadState({ type: 'pending', message: 'กำลังโหลดข้อมูลสถานี...' });

      try {
        const setupData = await fetchKioskSetupData();
        if (!active) {
          return;
        }

        setBindings(setupData.bindings);
        setDevices(setupData.devices);
        setRequests(setupData.requests);
        setRequestLoads(setupData.requestLoads);
        setLoadState({ type: 'success', message: '' });
      } catch (error) {
        if (!active) {
          return;
        }

        setLoadState({
          type: 'error',
          message: error instanceof Error ? error.message : 'ไม่สามารถโหลดข้อมูลสถานีได้.',
        });
      }
    }

    loadSetupData();
    return () => {
      active = false;
    };
  }, [visibilityRefreshTick]);

  useEffect(() => {
    function refreshWhenVisible() {
      if (document.visibilityState === 'visible') {
        refreshVisibleData();
      }
    }

    document.addEventListener('visibilitychange', refreshWhenVisible);
    return () => {
      document.removeEventListener('visibilitychange', refreshWhenVisible);
    };
  }, [refreshVisibleData]);

  return {
    bindings,
    devices,
    loadState,
    refreshVisibleData,
    requestLoads,
    requests,
    setBindings,
    setRequestLoads,
    setRequests,
    visibilityRefreshTick,
  };
}
